import * as React from 'react';
import { noop } from '../helper';

export interface ICoverageBoxContext {
  expandedSectionId: string | null;
  expandSection: (sectionId: string | null) => void;
}

export const CoverageBoxContext = React.createContext<ICoverageBoxContext>({
  expandSection: noop,
  expandedSectionId: null,
});
